module.exports = __webpack_public_path__ + "static/9-30bdd72c4d0aba1f5b85e6ad2ebd113c.jpg";